import React from 'react';
import { string, array, bool, func, node } from 'prop-types';
import { Label, SelectDropdown } from '@adsk/bim360-matrix-react-components';

const DropDown = ({
  label, disabled = false, placeholder = label,
  clearable = true, multi = true, searchable = false, ...restProps }) =>
  (<div className="Filter__field">
    <Label className="Filter__field-label">{label}</Label>
    <SelectDropdown
      disabled={disabled}
      placeholder={placeholder}
      clearable={clearable}
      multi={multi}
      searchable={searchable}
      {...restProps}
    />
  </div>);

export const DropDownPropTypes = {
  label: string.isRequired,
  selectedOptions: array.isRequired,
  options: array.isRequired,
  disabled: bool,
  searchable: bool,
  clearable: bool,
  multi: bool,
  optionRenderer: func,
  onChange: func.isRequired,
  placeholder: string,
  labelKey: string,
  valueKey: string,
  subtextGetter: func,
  selectClassName: string,
  searchIcon: node,
  searchPlaceholder: string,
};

DropDown.propTypes = DropDownPropTypes;
export default DropDown;
